import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';

const getEmptyState = (fetching) => ({isFetching: fetching || false, categories: {}});

class OrganisationCategoryStore extends ReduceStore {

    getInitialState() {
        return getEmptyState()
    }

    getByOrganisation(organisationId) {
        return this.getState().categories[ organisationId ];
    }
    getAll() {
        return this.getState().categories;
    }

    isFetching() {
        return this.getState().isFetching;
    }

    getIndex(organisationId, categoryId) {
        let index = -1;
        const categories = this._state.categories[organisationId];
        if (categories) {
            index = categories.findIndex(cat => !!cat && cat.categoryId === categoryId);
        }
        return index;
    }

    reduce(state, action) {
        let itemIndex;
        switch (action.type) {
            case ActionTypes.ORGANISATION_CATEGORY_LIST_REQUEST:
                return update(this.getState(), { isFetching: { $set: true } });

            case ActionTypes.ORGANISATION_CATEGORY_LIST_SUCCESS:
                return update(this.getState(), {
                    isFetching: { $set: false },
                    categories: { [action.payload.organisationId]: { $set: action.data } }
                });

            case ActionTypes.ORGANISATION_CATEGORY_LIST_FAILURE:
                return update(this.getState(), { isFetching: { $set: false } });

            case ActionTypes.CATEGORY_ORGANISATION_ADD_SUCCESS:
                itemIndex = this.getIndex(action.payload.organisationId, action.payload.id);
                return update(this.getState(), {
                    isFetching: { $set: false },
                    categories: {
                        [action.payload.organisationId]: 0 <= itemIndex ? { [itemIndex]: {$set: action.data} } : { $push: [action.data] }
                    }
                });

            case ActionTypes.CATEGORY_ORGANISATION_REMOVE_SUCCESS:
                itemIndex = this.getIndex(action.payload.organisationId, action.payload.id);
                return update(this.getState(), {
                    isFetching: { $set: false },
                    categories: { [action.payload.organisationId]: {$splice: [[itemIndex, 1]]} }
                });

            default:
                return state;
        }
    }
}

export default new OrganisationCategoryStore(CentricDispatcher);
